import { render, staticRenderFns } from "./assays-evaluations-grid.vue?vue&type=template&id=1351f090&scoped=true&"
import script from "./assays-evaluations-grid.ts?vue&type=script&lang=ts&"
export * from "./assays-evaluations-grid.ts?vue&type=script&lang=ts&"
import style0 from "./assays-evaluations-grid.scss?vue&type=style&index=0&id=1351f090&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1351f090",
  null
  
)

export default component.exports